import React from "react";

import { noop } from "lodash";

export const DnDContext = React.createContext<{
	draggable: {
		onStart: () => void;
		onEnd: (interactionInfo: null | { event: object }) => void;
		onBeginAction: (event: object, action: "move" | "resize", direction?: "UP" | "DOWN" | "LEFT" | "RIGHT") => void;
		onDropFromOutside: (interactionInfo: { start: Date; end: Date; allDay: boolean }) => void;
		dragFromOutsideItem: null | { start: Date; end: Date; allDay: boolean };
		draggableCondition: (event: object) => boolean;
		resizableCondition: (event: object) => boolean;
		selectableCondition?: (event: object) => boolean;
		dragAndDropAction: {
			interacting: boolean;
			action: null | "move" | "resize";
			direction: null | "UP" | "DOWN" | "LEFT" | "RIGHT";
			event: null | object;
		};
	};
}>({
	draggable: {
		onStart: noop,
		onEnd: noop,
		onBeginAction: noop,
		onDropFromOutside: noop,
		dragFromOutsideItem: null,
		draggableCondition: () => false,
		resizableCondition: () => false,
		selectableCondition: () => true,
		dragAndDropAction: {
			interacting: false,
			action: null,
			direction: null,
			event: null,
		},
	},
});
